




import Vue from 'vue';
import InfoFields from '@/common/components/support/InfoFields.vue';

export default Vue.extend({
  components: {
    InfoFields,
  },
});
